import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Button, Form, Label, Tab, List, Divider, Menu, Header, Sidebar, Ref, Icon, Message, Image, Card } from 'semantic-ui-react';
import Modal from 'shared/components/Modal';
import Stories from 'app/screens/Stories';
import CloseIcon from '@material-ui/icons/Close';

import config from 'shared/config/config';
import MobileCartGallery from 'app/components/MobileCartGallery';
import PhotoSwipeWrapper from 'shared/components/PhotoSwipe';
import MobileCartStripeForm from 'app/components/MobileCartStripeForm';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import PriceGuide from 'shared/components/PriceGuide';
import pwaModalStyles from 'shared/components/pwaModalStyles'
import Loading from 'shared/components/Loading';

import {
  getAvailableMomentIds,
  getAvailableMoments,
  getSelectedCalculations
} from 'shared/selectors/cartSelectors'

import {
  formatCurrency
} from 'shared/services/PriceService';

import {
  setPhotoSwipeItems
} from 'shared/actions/photoSwipeActions';

import {
  setPurchased,
  setMobileCartView,
  showCheckOutForm,
  applyDiscountCoupon,
  getPurchaseCalculations,
  getMoments,
  selectMoments,
  unselectMoments,
  showMobileCartPremiumGallery,
  reviewCartItems
} from 'shared/actions/cartActions';

import {
  showReceipt
} from 'shared/actions/homeActions';

import {
  showNavBar,
  hideNavBar,
  showNavBarHome,
} from 'shared/actions/navActions';

import { setDeeplinkStoryId, fetchAccountSettings } from 'shared/actions/storyActions';
import {
  enableSelection,
  disableSelection,
  selectAll,
  unselectAll
} from 'shared/actions/selectionActions';
import zIndex from '@material-ui/core/styles/zIndex';

const windowWidth = window.innerWidth;
const isMobile = windowWidth < 960;
const isSmall = windowWidth < 412;
const fontSize = parseInt(window.getComputedStyle(document.body).fontSize);

const styles = theme => ({
  photoSwipeStyle: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 99999
  },
  zoom: {
    position: 'absolute',
    zIndex: 1,
    right: 0,
    bottom: 0,
    fontSize: '3rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    color: '#fff'
  },
  waypoint: {
    position: 'absolute',
    left: 0,
    top: '-10vh'
  },
  mobileCartFrame: {
    height: '100%',
    width: '100%',
    margin: '0px 20px',
    transition: 'opacity 0.2s'
  },
  cartDetails: {
    width: '100%'
  },
  tabContainer: {
    border: 'none !important',
    background: config.pwa_stories_bg + ' !important'
  },
  priceGuide: {
    '&::before': {
      // uncomment to hide right border on Price Guide button
      //background: 'none !important'
    }
  },
  priceGuideHeader: {
    margin: '20px',
    fontWeight: 'bold'
  },
  cartToolbar: {
    padding: !isMobile ? '1em 1em !important' : '0em 0em !important',
    overflowX: !isSmall ? 'hidden' : 'auto',
    scrollbarWidth: 'thin'
  },
  galleryToolbar: {
    padding: !isMobile ? '1em 1em !important' : '0em 0em !important',
    border: 'none !important',
    boxShadow: 'none !important'
  },
  cartDetailLine: {
    display: 'flex',
    flexDirection: 'row'
  },
  messageBannerHeader: {
    color: config.pwa_default_font_color
  },
  messageBanner: {
    textAlign: 'center',
    background: config.pwa_default_bg_color + " !important",
    color: config.pwa_default_font_color + " !important",
    border: '.2em solid ' + config.pwa_default_font_color
  },
  checkOutSummary: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: '80vh',
    margin: '0 auto',
    background: config.pwa_default_bg_color,
    marginTop: '10vh',
    padding: '1.5rem',
    borderRadius: '5px',
    boxShadow: '2px 2px 5px 5px rgba(0,0, 0, 0.3)',
    border: config.pwa_default_font_color + " !important",
    color: config.pwa_default_font_color + " !important"
  },
  inputCoupon: {
    float: 'left',
    width: '60% !important',
    margin: '5px !important',
    borderColor: '#aaa !important',
    opacity: '1 !important',
  },
  btnApply: {
    float: 'right',
    width: '30% !important',
    margin: '5px !important'
  },
  errorLabel: {
    color: 'red !important'
  },
  checkoutModal: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: '25rem',
    margin: '0 auto',
    background: config.pwa_default_bg_color,
    marginTop: '10vh',
    padding: '1.5rem',
    borderRadius: '5px',
    boxShadow: '2px 2px 5px 5px rgba(0,0, 0, 0.3)',
    border: config.pwa_default_font_color + " !important",
    color: config.pwa_default_font_color + " !important"
  },
  removeMoment: {
    top: '4px',
    right: '4px',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'red',
    color: 'white'
  },
  ...pwaModalStyles
});

class MomentContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      moments: [],
      storyId: 0,
      activeIndex: 0,
      showPurchaseModal: false,
      showCart: false,
      totalPremiumCount: 0,
      email: '',
      showCartDetailsModal: false,
      showNoSelectedImageMsg: false,
      discountCode: '',
      errorMsg: '',
      onReview: false
    }
  }

  componentDidMount() {
    const { showPremiumGallery, setPhotoSwipeOpen, setMobileCartView, user } = this.props;

    this.purchaseButton = createRef();
    this.purchaseEmail = createRef();
    this.galleryContainer = createRef();

    this.getPremiumCount();

    if (showPremiumGallery) {
      this.loadPremiumMoments().then(() => {

        if (window.location.search.match(/gallery=true/)) {
          setPhotoSwipeOpen(true);
        }

      })

    }

    if (config.mobile_cart) {
      setMobileCartView(true);
    }

    if (user.email && !user.fake_email) {
      this.setState({ email: this.props.user.email });
    }

  }

  getPremiumCount() {
    let totalPremiumCount = 0

    for (let story of this.props.premiumStories) {
      totalPremiumCount += story.premium_count;
    }

    return totalPremiumCount;
  }

  async loadPremiumMoments() {
    const { stories } = this.props;

    if (stories.length === 0) {
      return Promise.resolve();
    }

    var storyId = this.props.openCartStoryId ? this.props.openCartStoryId : stories[0].id;

    this.setState({ storyId }, async () => {
      await new Promise(resolve => {
        this.props.getMoments('', storyId, { includePurchased: false });
      });
    })
  }

  handleTabChange = (e, data) => {
    if (data.activeIndex === 1) {
      // this.props.hideNavBar();
      this.props.setMobileCartView(true);
    } else {
      // this.props.showNavBar();
      this.props.showNavBarHome();
      this.props.setMobileCartView(false);
    }
  }


  handlePhotoSwipeClose = () => {
    const scrollNode = this.props.scrollNode && this.props.scrollNode.current;

    if (scrollNode && window.savedScroll) {
      scrollNode.scrollTop = window.savedScroll;
    }

    const event = new CustomEvent('show-moments');
    document.body.dispatchEvent(event);
  }

  handleSelectAll = (storyId) => {
    if (!this.isAllSelected()) {
      this.props.selectMoments(storyId, this.props.availableMomentIDs);
    } else {
      this.props.unselectMoments(storyId, this.props.availableMomentIDs);
    }
  }

  handleSelectMoment = (storyId, momentId) => {
    if (this.isSelected(momentId)) {
      this.props.unselectMoments(storyId, [momentId]);
    } else {
      this.props.selectMoments(storyId, [momentId]);
    }
  }

  isAllSelected = () => {
    const { openCartStoryId, availableMomentIDs, selectedMomentIds, onCartReview } = this.props;
    if (onCartReview) {
      this.updatePhotoSwipeItems(openCartStoryId, onCartReview);
    }
    return availableMomentIDs.length === selectedMomentIds.length;
  }

  isSelected(momentId) {
    const { selectedMomentIds } = this.props;
    return selectedMomentIds && selectedMomentIds.includes(momentId);
  }

  async stripeCallback(purchase, momentIds) {
    this.close();
    this.props.setPurchased(momentIds);
    this.props.unselectAll();
    this.props.disableSelection();
    this.props.showReceipt(purchase);
    this.props.hideNavBar();
  }

  close() {
    this.props.showCheckOutForm(false);
    this.setState({ showCartDetailsModal: false });
    window.currentModal && window.currentModal.close();
    document.body.style.overflowY = 'scroll';
  }

  handleBackToStories = () => {
    const { showMobileCartPremiumGallery, setDeeplinkStoryId } = this.props;
    showMobileCartPremiumGallery(false);
    setDeeplinkStoryId(null);
  }


  loadPropsMoments = () => {
    return this.props.availableMoments;
  }

  handleShowCartDetailModal = (visible) => {
    if (this.props.selectedMomentIds.length > 0)
      this.setState({ showCartDetailsModal: visible });
    else
      this.setState({ showNoSelectedImageMsg: true });
  }

  renderDiscountCode() {
    const { calculations, selectedMomentIds, classes, currency } = this.props;

    if (calculations?.discount_coupon_code && selectedMomentIds.length > 0) {
      let displayValue = "";
      if (calculations.discount_coupon_type === 0) {
        displayValue = (calculations.discount_coupon_value / 100) + '%'
      } else {
        displayValue = formatCurrency(calculations.discount_coupon_value, currency, true)
      }
      return [<br />, `- ${displayValue} (Code: ${calculations.discount_coupon_code})`]
    }

  }

  mapMoments = (moment) => {
    return {
      id: moment.id,
      position: moment.position,
      src: moment.preview_url,
      w: moment.width,
      h: moment.height,
      purchased: moment.purchased
    };
  }

  updatePhotoSwipeItems = (storyId, onReview) => {
    const { availableMoments, selectedMomentIds, setPhotoSwipeItems } = this.props;
    const storyIdTag = `${storyId}-unpurchased`;
    var moments = availableMoments.map((m) => {
      return this.mapMoments(m);
    });

    if (onReview) {
      moments = availableMoments.filter(m => selectedMomentIds.indexOf(m.id) >= 0).map((m) => {
        return this.mapMoments(m);
      });
    }
    setPhotoSwipeItems(storyIdTag, moments);
  }

  handleReviewCart = () => {
    const storyId = this.props.openCartStoryId;
    const onReview = this.state.onReview;
    this.setState({ onReview: !onReview });
    this.props.reviewCartItems(!onReview);
    this.updatePhotoSwipeItems(storyId, !onReview);
  }

  handleToggleSelectMoment = () => {
    const { openCartStoryId, selectedMomentIds, onCartReview } = this.props;
    if (onCartReview) {
      this.updatePhotoSwipeItems(openCartStoryId, onCartReview);
    }
  }

  renderMobileCart(storyId, moments, maxResolution) {
    if (!this.props.showPremiumGallery) {
      return this.renderStories();
    }

    if (!this.props.premiumGalleryLoaded) {
      return <Loading style={{ marginLeft: '-2rem', fontSize: '4rem' }} />;
    }

    let width = window.innerWidth - (fontSize * (this.props.showPremiumGallery ? 5 : 3));
    if (!isMobile && !config.mobile_cart) {
      width -= window.innerWidth * 0.26;
    }

    const { calculations, selectedMomentIds, classes, currency, availableMoments, onCartReview } = this.props;

    if (onCartReview) {
      moments = availableMoments.filter(m => selectedMomentIds.indexOf(m.id) >= 0);
    }

    let priceFormatted = formatCurrency(calculations?.price_per_unit, currency);
    let buyAllPriceFormatted = formatCurrency(calculations?.buy_all_price, currency);
    let boughtAll = calculations?.buy_all_applied;

    let standardPrice = null;
    // hiding the price and buy app price in the cart readout.
    // leaving this commented out for reference
    //if (boughtAll) {
    //    standardPrice = <Table.Row style={{ textAlign: 'left' }}>
    //      <Table.Cell>
    //        <FormattedMessage {...messages.cart_add_image_no_cost} />
    //      </Table.Cell>
    //    </Table.Row>;
    //  } else {
    //    standardPrice = <Table.Row style={{ textAlign: 'left' }}>
    //      <Table.Cell>
    //        <FormattedMessage {...withValues(messages.cart_standard_price, { amount: priceFormatted })} />
    //      </Table.Cell>
    //    </Table.Row>;
    //  }
    let buyallPrice = null
    // hiding the price and buy app price in the cart readout.
    // leaving this commented out for reference
    //if (config.customer !== 'hpx') {
    //    buyallPrice = (
    //      <Table.Row style={{ textAlign: 'left' }}>
    //        <Table.Cell>
    //          <FormattedMessage {...withValues(messages.cart_buy_all_at_price, { amount: buyAllPriceFormatted })} />
    //        </Table.Cell>
    //     </Table.Row>
    //     )
    //}

    return (
      <div>
        <Sidebar.Pushable>
          <Sidebar
            as={Menu}
            visible={this.state.showCart}
            animation='push'
            vertical
            inverted={config.customer === 'hpx'}
            direction='right'>
            <Menu.Item>
              <PriceGuide />
            </Menu.Item>
            <Menu.Item>
              <Button fluid onClick={() => {
                this.setState({
                  showCart: false
                })
              }} >
                <FormattedMessage {...messages.button_close} />
              </Button>
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher className={classes.tabContainer} dimmed={this.state.showCart}>
            <Menu fluid className={classes.cartToolbar}
              compact={isMobile} inverted={config.customer === 'hpx'}>
              {
                this.props.premiumStories.length > 1 &&
                <Menu.Item as='a' onClick={this.handleBackToStories.bind(this)}>
                  <Icon name='arrow left' />
                </Menu.Item>
              }
              {
                config.customer !== 'hpx' &&
                <Menu.Item className={classes.priceGuide} as='a'
                  onClick={() => { this.setState({ showCart: true }) }} >
                  <Icon name='dollar sign' />
                  <FormattedMessage {...messages.cart_price_guide} />
                </Menu.Item>
              }
              {
                <Menu.Menu position='right'>
                  <Menu.Item as='a' className={classes.messageBannerHeader}
                    onClick={this.handleReviewCart.bind(this)} >
                    {this.state.onReview ?
                      <div>
                        <Icon name='chevron left' />
                        <FormattedMessage {...messages.button_back_to_cart} />
                      </div>
                      :
                      <div>
                        <Icon name='checkmark' />
                        <FormattedMessage {...messages.button_review_cart} />
                      </div>
                    }
                  </Menu.Item>
                  <Menu.Item as='a' onClick={this.handleShowCartDetailModal.bind(this, true)}>
                    <Icon name='shopping cart' />
                    <Label color='red' floating={!isMobile}>
                      {selectedMomentIds.length}
                    </Label>
                  </Menu.Item>
                </Menu.Menu>
              }
            </Menu>
            {
              this.state.showNoSelectedImageMsg && this.props.selectedMomentIds.length == 0 &&
              <Message warning floating>
                <p><FormattedMessage {...messages.cart_no_selected_image} /></p>
              </Message>
            }
            <Message className={classes.messageBanner}>
              <Message.Content>
                <div className={classes.cartDetailLine}>
                  <div className={classes.messageBannerHeader} style={{ display: 'flex', flexGrow: 1 }}>
                    <label>
                      {selectedMomentIds.length} &nbsp;
                      <FormattedMessage {...messages.cart_digital_image} />
                    </label>
                  </div>
                  <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', textAlign: 'right' }}>
                    {formatCurrency(calculations?.raw_total, currency, true)}
                    {calculations?.discount_coupon_code && this.renderDiscountCode()}
                    {
                      calculations?.tax > 0 &&
                      [<br />, "+ " + formatCurrency(calculations?.tax, currency, true) + " (Tax)"]
                    }
                  </div>
                  <br />
                </div>
                {standardPrice}
                {buyallPrice}
                <br />
                {
                  config.customer !== 'hpx' &&
                  <div style={{ textAlign: 'left' }}>
                    <i><FormattedMessage {...messages.cart_price_guide_notes} /></i>
                  </div>
                }
              </Message.Content>
            </Message>
            <Sidebar.Pusher className={classes.tabContainer} dimmed={this.state.showCart}>
              <Menu fluid className={classes.galleryToolbar}
                compact={isMobile} inverted={config.customer === 'hpx'}>
                <Menu.Item as='a' onClick={this.handleSelectAll.bind(this, storyId)}>
                  {
                    this.isAllSelected.bind(this) ?
                      <Icon name='check circle' style={{ color: config.pwa_checkmark_color }}></Icon> :
                      <Icon name='check circle outline' />

                  }
                  <FormattedMessage {...messages.form_label_select_all} />
                </Menu.Item>
              </Menu>
            </Sidebar.Pusher>
            <MobileCartGallery
              index={0}
              resolution={0}
              maxResolution={maxResolution}
              progressive={true}
              direction={"column"}
              columns={isMobile ? 2 : config.mobile_cart ? 4 : 3}
              containerWidth={width}
              forceVisible={true}
              scrollNode={this.props.scrollNode}
              moments={moments}
              storyId={this.props.openCartStoryId}
              disableScrollListener={true}
              onToggleSelectMoment={this.handleToggleSelectMoment.bind(this)}
            >
            </MobileCartGallery>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        <PhotoSwipeWrapper
          onClose={this.handlePhotoSwipeClose}
          // printStoreUrl={settings.print_store_url}
          isMobileCart={true}
          showPrintStore={false}
          // passMomentToPrintStore={settings.append_store_moment}
          onClickAddToCart={this.handleSelectMoment}
          showActions={false}
          storyId={`${storyId}-unpurchased`}
          moments={moments} />
        {storyId && this.renderPurchaseModal(storyId, classes)}
        {storyId && this.renderCartDetailsModal(storyId, classes, selectedMomentIds, standardPrice, calculations, currency, availableMoments)}
      </div>
    );
  }

  renderCartDetailsModal(storyId, classes, selectedMomentIds, standardPrice, calculations, currency, availableMoments) {
    const { unselectMoments } = this.props;
    const selectedMoments = availableMoments.filter(m => selectedMomentIds.indexOf(m.id) >= 0);
    return (
      <Modal disableScrollbar={true}
        disableDrag={true}
        isOpen={this.state.showCartDetailsModal}
        close={this.close.bind(this)}>
        <div className={classes.modalOverlay} onClick={this.close.bind(this)}></div>
        <div className={classes.checkoutModal}>
          <CloseIcon className={classes.modalCloseIcon} onClick={this.close.bind(this)} />
          <div className={classes.cartDetails}>
            <Header className={classes.modalHeader}>
              <FormattedMessage {...messages.cart_cart_details} />
            </Header>
            <Divider />
            <List relaxed divided style={{ textAlign: 'left' }}>
              <List.Item>
                <List.Content verticalAlign='middle'>
                  <label>
                    {selectedMomentIds.length} &nbsp;
                    <FormattedMessage {...messages.cart_digital_image} />
                  </label>
                </List.Content>
              </List.Item>
              <List.Item>
                {
                  <List.Content>
                    {standardPrice}
                  </List.Content>
                }
              </List.Item>
            </List>
            <br />
            <Button primary fluid icon='sign-out alternate' content={formatCurrency(calculations?.total, currency, true)}
              onClick={this.handleCheckout.bind(this)} labelPosition='right'>
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  renderPurchaseModal(storyId, classes) {
    return (
      <Modal disableScrollbar={true}
        disableDrag={true}
        isOpen={this.props.checkOutVisible}
        close={this.close.bind(this)}>
        <div className={classes.modalOverlay} onClick={this.close.bind(this)}></div>
        <div className={classes.modal}>
          <CloseIcon className={classes.modalCloseIcon} onClick={this.close.bind(this)} />
          <div className={classes.modalStage} style={{ height: '30vh !important' }}>
            {this.renderCardCheckoutSlide(storyId, classes)}
          </div>
        </div>
      </Modal>
    );
  }

  handleApplyDiscountCoupon() {
    const { availableMoments, applyDiscountCoupon, getPurchaseCalculations, openCartStoryId,
      calculations } = this.props;
    applyDiscountCoupon(openCartStoryId, calculations.product_id, this.state.discountCode.toLocaleUpperCase(), calculations?.raw_total).then((response) => {
      getPurchaseCalculations(openCartStoryId, availableMoments.length, this.state.discountCode.toLocaleUpperCase());
      this.setState({ errorMsg: response });
    });
  }

  handleCheckout = async () => {
    const { selectedMomentIds, showCheckOutForm } = this.props;

    if (selectedMomentIds.length > 0) {
      this.setState({ showCartDetailsModal: false }, () => {
        showCheckOutForm(true);
      })
    } else {
      this.setState({ showNoSelectedImageMsg: true });
    }
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  renderCardCheckoutSlide = (storyId, classes) => {
    const { stripeSettings, user, calculations, purchaseLoading, premiumStories,
      selectedMomentIds, currency, accountSettings } = this.props;

    const selectedStory = premiumStories.find((x) => x.id === storyId);

    let accountId = 0;
    let stripeKey = null;
    let discountCodes = false;

    if (selectedStory) {
      accountId = selectedStory.account_id;
      stripeKey = stripeSettings[storyId]?.stripe_key;
      discountCodes = accountSettings[storyId]?.discount_codes;
    }

    return (
      <div>
        <div>
          <span>
            <Header size='large' className={classes.modalHeader}>
              <FormattedMessage {...messages.cart_checkout} />
            </Header>
          </span>
          <Form>
            <Form.Field>
              <span>
                <Header size='small' className={classes.modalText}><FormattedMessage {...messages.cart_credit_debit_card} /></Header>
              </span>
            </Form.Field>
            {
              discountCodes &&
              <Form.Field>
                <span>

                  <FormattedMessage {...messages.cart_coupon_code}>
                    {(msg) => (
                      <input value={this.state.discountCode} className={classes.inputCoupon} type='text' placeholder={msg}
                        onChange={(e) => { this.setState({ discountCode: e.target.value }) }} />
                    )
                    }
                  </FormattedMessage>
                  <Button className={classes.btnApply} color='green' fluid onClick={this.handleApplyDiscountCoupon.bind(this)}><FormattedMessage {...messages.cart_apply_coupon} /></Button>
                </span>
              </Form.Field>
            }
            <Form.Field>
              <label className={classes.errorLabel}>{this.state.errorMsg && <FormattedMessage {...messages[this.state.errorMsg]} />}</label>
            </Form.Field>
            <Form.Field>
              <Divider />
              <div className={classes.cartDetailLine}>
                <div style={{ display: 'flex', flexGrow: 1 }}>
                  <label>
                    {selectedMomentIds.length} &nbsp;
                    <FormattedMessage {...messages.cart_digital_image} />
                  </label>
                </div>
                <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', textAlign: 'right' }}>
                  {formatCurrency(calculations?.raw_total, currency, true)}
                  {this.renderDiscountCode()}
                </div>
              </div>
              {
                calculations?.tax > 0 &&
                <div>
                  <Divider />
                  <div className={classes.cartDetailLine}>
                    <div style={{ display: 'flex', flexGrow: 1 }}>
                      <label>
                        Tax
                      </label>
                    </div>
                    <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
                      + {formatCurrency(calculations?.tax, currency, true)}
                    </div>
                  </div>
                </div>
              }
              {
                calculations?.total != calculations?.raw_total &&
                <div>
                  <Divider />
                  <div className={classes.cartDetailLine}>
                    <div style={{ display: 'flex', flexGrow: 1 }}>
                      <label>
                        Total
                      </label>
                    </div>
                    <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
                      {formatCurrency(calculations?.total, currency, true)}
                    </div>
                  </div>
                </div>
              }
            </Form.Field>
            <Form.Field>
              <span>
                <input ref={this.purchaseEmail} type={user.fake_email ? 'text' : 'hidden'} value={this.state.email}
                  onChange={this.handleEmailChange.bind(this)} placeholder='Enter E-mail Address' ></input>
              </span>
              <Divider />
              <MobileCartStripeForm button={this.purchaseButton} freeMode={calculations?.total === 0}
                processingText={<FormattedMessage {...messages.cart_purchasing} /> + "..."} email={this.purchaseEmail}
                callback={this.stripeCallback.bind(this)} accountId={accountId} storyId={storyId} stripeKey={stripeKey} />
            </Form.Field>
          </Form>
        </div>
        <br />
        <div className={classes.modalButtons} style={{ marginTop: '1rem' }}>
          <Ref innerRef={this.purchaseButton}>
            <Button color='green' fluid disabled={purchaseLoading} loading={purchaseLoading}>
              {
                purchaseLoading ? <FormattedMessage {...messages.cart_purchasing} /> :
                  <FormattedMessage {...messages.cart_purchase} />
              }
            </Button>
          </Ref>
        </div>
      </div>
    );
  }

  renderStories() {
    const stories = (this.props.isMobileCart || config.mobile_cart) ? this.props.premiumStories : this.props.stories;
    return <Stories stories={stories}
      onAdd={this.props.onAdd}
      deeplinkStoryId={this.props.deeplinkStoryId} />
  }

  render() {
    const { classes } = this.props;

    let maxResolution = 3;

    if (windowWidth <= 960) {
      maxResolution = 1;
    }
    if (windowWidth <= 1280) {
      maxResolution = 2;
    }


    const panes = [
      {
        menuItem: {
          key: <FormattedMessage {...messages.cart_purchased} />,
          content: <FormattedMessage {...messages.cart_purchased} />
        }, render: () => <Tab.Pane className={classes.tabContainer}>
          <div>
            {this.renderStories()}
          </div>
        </Tab.Pane>
      },
      {
        menuItem: {
          key: <FormattedMessage {...messages.cart_unpurchased} />, content: <div>
            <FormattedMessage {...messages.cart_unpurchased} /> &nbsp;
            <Label circular color='red'>
              {this.getPremiumCount()}
            </Label>
          </div>
        }, render: () => <Tab.Pane className={classes.tabContainer}>
          {this.renderMobileCart(this.props.openCartStoryId, this.loadPropsMoments(), maxResolution)}
        </Tab.Pane>
      }
    ]

    let view = null;
    // If this is a mobile cart link, render it
    if (config.mobile_cart === true) {
      view = this.renderMobileCart(this.props.openCartStoryId, this.loadPropsMoments(), maxResolution)
    } else {
      // If it's a consumer app link and they have premmium photos, give them both
      if (this.getPremiumCount() > 0) {
        view = (
          <Tab
            className={classes.tabContainer}
            menu={{ inverted: config.customer === 'hpx' ? true : false, tabular: true }}
            panes={panes}
            onTabChange={this.handleTabChange.bind(this)}
          />
        )
      } else {
        view = this.renderStories()
      }
    }

    return (
      <div style={{ width: '100%' }}>
        {view}
      </div>
    )
  }
}



const mapStateToProps = state => ({
  storyMoments: state.storyReducer.storyMoments,
  availableMoments: getAvailableMoments(state),
  availableMomentIDs: getAvailableMomentIds(state),
  stripeSettings: state.storyReducer.stripeSettings,
  currency: state.cartReducer.calculations.currency,
  calculations: getSelectedCalculations(state),
  pricingModel: state.cartReducer.calculations.pricing_model,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  purchases: state.cartReducer.purchases,
  discounts: state.cartReducer.calculations.discounts,
  user: state.userReducer.user,
  showPremiumGallery: state.cartReducer.showPremiumGallery,
  isMobileCart: state.cartReducer.isMobileCart,
  openCartStoryId: state.storyReducer.openCartStoryId,
  checkOutVisible: state.cartReducer.checkOutVisible,
  purchaseLoading: state.cartReducer.purchaseLoading,
  accountSettings: state.storyReducer.accountSettings,
  premiumGalleryLoaded: state.cartReducer.premiumGalleryLoaded,
  onCartReview: state.cartReducer.onCartReview
});

export default connect(mapStateToProps, {
  fetchAccountSettings, applyDiscountCoupon, setDeeplinkStoryId, showCheckOutForm, showMobileCartPremiumGallery,
  setMobileCartView, selectMoments, unselectMoments, setPhotoSwipeItems, getMoments, unselectAll,
  enableSelection, disableSelection, selectAll, showNavBar, hideNavBar, showNavBarHome, setPurchased,
  showReceipt, getPurchaseCalculations, reviewCartItems
})(withStyles(styles, { withTheme: true })(MomentContainer));
